const contact = {
  hero: {
    eyebrow: "Свяжитесь с нами",
    title:   "Мы готовы помочь",
    sub:     "Напишите через форму, позвоните или выберите удобный мессенджер.",
  },
  info: {
    phoneTitle:  "Телефон и мессенджеры",
    emailTitle:  "Email",
    socialTitle: "Соцсети",
    hoursTitle:  "Часы работы",
    hours1:      "Понедельник – Пятница: 9:00 – 18:00",
    hours2:      "Суббота: 10:00 – 15:00",
    hours3:      "Воскресенье: по записи",
  },
  form: {
    title:       "Отправить сообщение",
    name:        "Имя",
    namePh:      "Ваше имя",
    email:       "Email",
    phone:       "Телефон (необязательно)",
    message:     "Сообщение",
    messagePh:   "Расскажите, что вы ищете...",
    submit:      "Отправить",
    sending:     "Отправка…",
    error:       "Что-то пошло не так. Попробуйте ещё раз или свяжитесь с нами напрямую.",
    successTitle:"Сообщение отправлено!",
    successSub:  "Мы ответим вам в течение 24 часов.",
  },
};

export default contact;
